import { render, staticRenderFns } from "./couponListZH.vue?vue&type=template&id=18e366fc&scoped=true&"
import script from "./couponListZH.vue?vue&type=script&lang=ts&"
export * from "./couponListZH.vue?vue&type=script&lang=ts&"
import style0 from "./couponListZH.vue?vue&type=style&index=0&id=18e366fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e366fc",
  null
  
)

export default component.exports